import { Link } from 'react-router-dom';
import { whyChooseFeatureCards } from '../data/whyChooseMyRoomsAI';

function WhyChooseMyRoomsAISection() {
  return (
    <section
      id="why-choose"
      className="why-choose-section container section"
      aria-label="Why choose MyRoomsAI"
    >
      <div className="section-heading why-choose-section__heading">
        <h2>
          Why Choose{' '}
          <span className="shop-furniture-showcase__title-accent shop-furniture-showcase__title-accent--gradient">
            MyRoomsAI
          </span>{' '}
          for Home Design?
        </h2>
        <p>
          AI-powered home design tools built to help you redesign rooms, transform floor plans,
          and visualize realistic home ideas faster, easier, and with less cost.
        </p>
      </div>

      <div className="why-choose-feature-list">
        {whyChooseFeatureCards.map((card) => {
          return (
            <article
              key={card.id}
              className={`why-choose-feature-card${
                card.imageSide === 'right' ? ' why-choose-feature-card--image-right' : ''
              }`}
            >
              <div
                className="why-choose-feature-card__visual"
                aria-hidden={!card.imageSrc}
              >
                {card.imageSrc ? (
                  <img
                    src={card.imageSrc}
                    alt={card.imageAlt || ''}
                    loading="lazy"
                    decoding="async"
                  />
                ) : (
                  <div className="why-choose-feature-card__visual-placeholder" />
                )}
              </div>

              <div className="why-choose-feature-card__content">
                <h3 className="why-choose-feature-card__title">{card.title}</h3>
                <p className="why-choose-feature-card__text">{card.text}</p>
                <Link to={card.ctaTo} className="btn btn-primary why-choose-feature-card__cta">
                  {card.ctaLabel}
                </Link>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default WhyChooseMyRoomsAISection;
